import React, { useCallback, useState } from 'react';

import { Button, Modal, Input } from '..';
import { useUpdateEffect } from '@hooks';

export type EditorModalProps = {
  open: boolean;
  initialContent: string;

  onClose: () => void;
  onSave: (content: string) => void;
};

export const EditorModal: React.FC<EditorModalProps> = ({
  open,
  initialContent,

  onClose,
  onSave,
}) => {
  const [text, setText] = useState(initialContent || '');

  useUpdateEffect(() => {
    if (!open) return;

    setText(initialContent);
  }, [open]);

  const handleSave = useCallback(() => {
    onSave(text);
    onClose();
  }, [text, onSave, onClose]);

  return (
    <Modal title="Edit Text" size="big" open={open} onClose={onClose}>
      <div className="flex flex-col gap-sm h-full">
        <Input value={text} onChange={setText} multiline rows={8} />
        <div className="flex items-center w-full justify-between gap-x-sm mt-xs">
          <div className="flex gap-x-sm ">
            <Button
              children="Cancel"
              className="flex-1 min-w-0"
              onClick={onClose}
            />
            <Button
              children="Save"
              onClick={handleSave}
              type="primary"
              className="flex-1 min-w-0"
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default React.memo(EditorModal) as typeof EditorModal;
